export default __webpack_public_path__ + "static/media/sholder_detail.8be23d00.png";